import React from 'react';
import './css/Producers.css';
import { Tabs, Row, Col } from "antd";
import ManageMovie from './ManageMovie';
import IdentitiesTab from './IdentitiesTab';
import AddMovie from './AddMovie';
import { getUploadsApi, getAddMovieObjApi } from './utils/ApiUtils';
import { COLORS } from './utils/Constants';

const { TabPane } = Tabs;
let shouldReload = true, hmid = false;

export default class Producers extends React.Component {
  state = { size: 'small', selectedFile: null, countryVal: 'Country', index: '0', payModal: false, 
    isLoading: false, hmid: false, uploadedMovies: [], addMovieObj: '', sessionValue: '' };

  componentDidMount() {
    shouldReload = true;
    let sessionValue = localStorage.getItem('localStorageSession') || '';
    console.log('sessionValue='+sessionValue);
    if(sessionValue) {
      this.setState({ sessionValue: sessionValue });
    }
    let userObj = this.props.userObject;
    if(userObj&&userObj.hmid) {
      hmid = true;
    }
    let windowUrl = window.location.href;
    if(windowUrl.includes('managemovie')) {
      this.setState({ index: '1', isLoading: true });
      this.props.showLoader(true);
      this.loadData(sessionValue);
    } else if(windowUrl.includes('identities')) {
      this.setState({ index: '2', isLoading: true });
      this.props.showLoader(true);
    }
  }
  componentDidUpdate() {
    let userObj = this.props.userObject;
    if((!hmid)&&userObj&&userObj.hmid) {
      hmid = true;
      this.setState({ hmid: true });
    }
  }
  loadData = (sessionValue) => {
    getUploadsApi(sessionValue)
      .then(response => {
        console.log('got uploads data='+(response));
        if(response.ok) {
          this.setState({ uploadedMovies: response.info, isLoading: false });
          this.props.showLoader(false);
          let latestObject = response.info.at(-1);
          console.log('latestObject webhookExecuted='+latestObject.movieInfo.webhookExecuted);
          if(shouldReload&&(!latestObject.movieInfo.webhookExecuted)) {
            shouldReload = false;
            this.loadData(sessionValue);
          }
        } else {
          console.log('Getting uploads failed!');
          this.setState({ uploadedMovies: [], isLoading: false });
          this.props.showLoader(false);
        }
      })
      .catch((error) => {
        console.log('Error fetching uploads='+JSON.stringify(error));
        this.setState({ uploadedMovies: [], isLoading: false });
        this.props.showLoader(false);
      }); 
  }
  updateMovieList = (moviesList) => {
    this.setState({ uploadedMovies: moviesList });
  }
  showHideLoader = (value) => {
    this.props.showLoader(value);
  }
  refreshMoveList = () => {
    console.log('Need to refresh the movie list.');
    this.loadData(this.state.sessionValue);
  }
  getPreviousAddMovieObj = (sessionValue) => {
    getAddMovieObjApi(sessionValue)
    .then(response => {
      console.log('got add movie data='+JSON.stringify(response.info));
      if(response.ok) {
        this.setState({ addMovieObj: response.info });
      } else {
        console.log('Getting add movie failed!');
      }
    })
    .catch((error) => {
      console.log('Error getting add movie='+JSON.stringify(error));
    }); 
  }
  tabChange = (key) => {
    console.log('key='+key);
    this.setState({ index: key });
    if(key==='2') {
      window.history.replaceState(null, null, "/identities");
    } else if(key==='1') {
      window.history.replaceState(null, null, "/managemovie");
      let oldList = this.state.uploadedMovies;
      if(oldList.length===0) {
        this.setState({ isLoading: true });
        this.props.showLoader(true);
        this.loadData(this.state.sessionValue);
      }
    } else {
      window.history.replaceState(null, null, "/addmovie");
    }
  }
  sendToManage = () => {
    shouldReload = true;
    window.history.replaceState(null, null, "/managemovie");
    this.props.showLoader(true);
    this.setState({ index: '1' });
    this.loadData(this.state.sessionValue);
  }
  render() {
    console.log('index='+this.state.index);
    return (
      <div className="App">
        <div style={{ justifyContent: "center", backgroundColor: COLORS.darkBlue }}>
          <Tabs onChange={(k) => { this.tabChange(k) }} className="Producer" size='large' type='card' activeKey={this.state.index} 
          style={{ backgroundColor: null }}>
            <TabPane tab="ADD NEW MOVIE" key="0" style={{ fontSize: '14px', backgroundColor: COLORS.blue5a6a7a }}>
              <Row style={{ width: '100%', height:'100%', backgroundColor: COLORS.blue5a6a7a, margin: 0, padding: 0, paddingTop: 40 }}>
                <Col lg={{ span: 20, offset: 2 }} xl={{ span: 16, offset: 4 }} xxl={{ span: 14, offset: 5 }}>
                  <AddMovie generalInfoData= {this.props.generalInfoData} countriesData={this.props.countriesData} 
                  addMovieObj={this.state.addMovieObj} tabLanguages={this.props.tabLanguages} 
                  sendToManage={(uploadedMovies) => { this.sendToManage(uploadedMovies) }} />
                </Col>
              </Row>
            </TabPane>
            <TabPane tab="MANAGE MY MOVIES" key="1" style={{ fontSize: '14px', backgroundColor: COLORS.blue5a6a7a }}>
              <Row style={{ width: '100%', height:'100%', backgroundColor: COLORS.blue5a6a7a, margin: 0, padding: 0, paddingTop: 40 }}>
                <Col lg={{ span: 20, offset: 2 }} xl={{ span: 16, offset: 4 }} xxl={{ span: 14, offset: 5 }}>
                  { this.state.isLoading 
                  ?
                  <div style={{ display: 'flex', height: '100vh' }} />
                  :
                  <ManageMovie generalInfoData={this.props.generalInfoData} countriesData={this.props.countriesData} userObject={this.props.userObject}
                    uploadedMovies={this.state.uploadedMovies} sessionValue={this.state.sessionValue} showHideLoader={this.showHideLoader}
                    refreshMoveList={this.refreshMoveList} updateMovieList={this.updateMovieList} />
                  }
                </Col>
              </Row>
            </TabPane>
            { hmid &&
            <TabPane tab="IDENTITIES" key="2" style={{ fontSize: '14px', backgroundColor: COLORS.blue5a6a7a }}>
              <Row style={{ width: '100%', height:'100%', backgroundColor: COLORS.blue5a6a7a, margin: 0, padding: 0, paddingTop: 40 }}>
                <Col span={24}>
                  <IdentitiesTab generalInfoData={this.props.generalInfoData} countriesData={this.props.countriesData} userObject={this.props.userObject}
                    uploadedMovies={this.state.uploadedMovies} sessionValue={this.state.sessionValue} showHideLoader={this.showHideLoader}
                    refreshMoveList={this.refreshMoveList} updateMovieList={this.updateMovieList} />
                </Col>
              </Row>
            </TabPane>
            }
          </Tabs>
        </div>
      </div>
    );
  };
};
